class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
   
    if(parsedState.key){
      this.cartItemKey = parsedState.key;
    }
    else {      
      let item_key_index = parsedState.items.length - 1;
      this.cartItemKey = parsedState.items[item_key_index].key;
    }
    
    this.getSectionsToRender().forEach((section) => {
      console.log('section',section);
      if(section){
        let sectionElement = document.getElementById(section.id);
        if (sectionElement) { // Only update if the element exists
          sectionElement.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        } 
        else {
          console.warn(`Element with ID '${section.id}' not found.`);
        }  
      }          
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,            
      },
      {
        id: 'cart-icon-bubble',
      },     
    ];
  }

  /*getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }*/
  
  getSectionInnerHTML(html, selector = '.shopify-section') {
    let parsedDoc = new DOMParser().parseFromString(html, 'text/html');
    let sectionElement = parsedDoc.querySelector(selector);
    console.log(sectionElement,selector)

    if (sectionElement) {
        return sectionElement.innerHTML;
    } else {
        console.warn(`Selector '${selector}' not found in parsed HTML.`);
        return ''; // Return an empty string to prevent errors
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
